import { reactive } from 'vue'
import type { Sprint, RequirementType, Priority, DefinitionStatus, DevelopmentStatus } from '@/types'

export interface BacklogFilters {
  search: string
  projectId: string
  applicationId: string
  type: RequirementType | ''
  priority: Priority | ''
  definitionStatus: DefinitionStatus | ''
  developmentStatus: DevelopmentStatus | ''
  sprintId: string // '' = all, 'none' = unassigned, or sprint ID
  assignedTo: string
  label: string
}

export interface BacklogState {
  sprints: Sprint[]
  selectedSprintId: string | null
  isLoading: boolean
  isSprintLoading: boolean
  error: string | null
  filters: BacklogFilters
}

export const getInitialState = (): BacklogState => ({
  sprints: [],
  selectedSprintId: null,
  isLoading: false,
  isSprintLoading: false,
  error: null,
  filters: {
    search: '',
    projectId: '',
    applicationId: '',
    type: '',
    priority: '',
    definitionStatus: '',
    developmentStatus: '',
    sprintId: '',
    assignedTo: '',
    label: '',
  },
})

export const createState = (): BacklogState => {
  return reactive(getInitialState())
}

export const resetState = (state: BacklogState): void => {
  const initial = getInitialState()
  state.sprints = initial.sprints
  state.selectedSprintId = initial.selectedSprintId
  state.isLoading = initial.isLoading
  state.isSprintLoading = initial.isSprintLoading
  state.error = initial.error
  state.filters = initial.filters
}
